module.exports = __webpack_public_path__ + "img/full7-min.7f410c0c.png";